<template>
	<div class="phfilwork">
		<el-backtop ></el-backtop>
		<hpheader></hpheader>
		<div v-if="fileworkno==1" class="elicenviron" >
			<div class="elicabimgpubu">
				<div class="elicabimgpubu-item" v-for="(item,index) in pcelicenvironcosn" :key="index">
					<img :src="item.image" />
				</div>
			</div>
		</div>
		<div v-if="fileworkno==2" class="happyfile" >
			<div class="happabimgpubu">
				<div class="happabimgpubu-item" v-for="(item,index) in pchappyfilecosn" :key="index">
					<img :src="item.image" />
				</div>
			</div>
		</div>
		<div v-if="fileworkno==3" class="salarywel" v-html="pcsalarywelcosn"></div>
		<div v-if="fileworkno==4" class="developen" v-html="developenconts"></div>
		<hpfooter></hpfooter>
	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
		import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	export default{
		data(){
			return{
				fileworkno:1,
				pcelicenvironcosn:'',
				developenconts:'',
				pchappyfilecosn:'',
				pcsalarywelcosn:'',
				list_img: [
				 //    { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcaboutpubu1.png"),id:1,is_cover:false},
				 //    { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcaboutpubu2.png"),id:2,is_cover:false},
				 //    { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcaboutpubu3.png"),id:3,is_cover:false},
				 //    { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcaboutpubu4.png"),id:4,is_cover:false},
				 //    { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcaboutpubu5.png"),id:5,is_cover:false},
					// { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcaboutpubu6.png"),id:6,is_cover:true},
					// { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcaboutpubu2.png"),id:2,is_cover:false},
					// { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcaboutpubu1.png"),id:3,is_cover:false},
					// { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcaboutpubu4.png"),id:4,is_cover:false},
				],
			}
		},
		created() {
			this.getParams()
			this.pcsalarywel()
			this.pcdevelopen()
			this.pcelicenviron()
			this.pchappyfile()
			window.scrollTo(0,0);
			this.ress()
		},
		components:{
			hpheader,
			hpfooter,
		},
		methods:{
			getParams(){
				this.fileworkno = this.$route.query.e
			},
			pchappyfile(){//快乐生活
				let data={
						mold:'h5',
						
					}
						this.$api.get_people_life(data).then((res) => {
						this.pchappyfilecosn=res.data
				});
			},
			pcelicenviron(){//工作环境
				let data={
						mold:'h5',
						
					}
						this.$api.get_people_around(data).then((res) => {
						this.pcelicenvironcosn=res.data
				});
			},
			pcsalarywel(){//薪资福利
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						
					}
						this.$api.get_people_welfare(data).then((res) => {
						this.pcsalarywelcosn=res.data.content
				});
			},
			pcdevelopen(){//培训发展
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					}
					this.$api.get_people_train(data).then((res) => {
					this.developenconts=res.data.content
				});
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
		},
	}
</script>

<style>
	body{
		padding: 0;
		margin: 0;
	}
	.phfilwork{
		width: 100%;
		height: 100%;
		padding: 0.88rem 0;
	}
	.elicabimgpubu{
		margin: 0.2rem;
		column-count: 2;
		column-gap: 0.2rem;
	}
	.elicabimgpubu-item{
		margin-bottom: 0.2rem;
		overflow: hidden;
		border-radius: 0.2rem;
	}
	.elicabimgpubu-item img{
		width: 100%;
		height:100%;
		/* max-width: 920px; */
		transition: all .75s linear;
	}
	.elicabimgpubu-item:hover img{
		cursor: pointer;
		transform: scale(1.02,1.02); 
	}
	.elicenviron{
		padding: 0 0.4rem;
	}
	
	.happyfile{
		padding: 0 0.4rem;
	}
	.happabimgpubu{
		margin: 0.2rem;
		column-count: 2;
		column-gap: 0.2rem;
	}
	.happabimgpubu-item{
		margin-bottom: 0.2rem;
		overflow: hidden;
		border-radius: 0.2rem;
	}
	.happabimgpubu-item img{
		width: 100%;
		height:100%;
		transition: all .75s linear;
	}
	.happabimgpubu-item:hover img{
		cursor: pointer;
		transform: scale(1.02,1.02); 
	}
	.salarywel{
		overflow: hidden;
		font-size: 0.18rem;
		padding: 0 0.3rem !important;
	}
	.developen{
		font-size: 0.18rem;
		padding: 0 0.3rem !important;
	}
</style>
